import { createType } from 'framework/utils/createType';

export const SalesDetailTabTypes = createType('contents', 'accountsReceivableAndPayments');
export type SalesDetailTabType = typeof SalesDetailTabTypes[number];
